import React from 'react';
import FilterTable from './filterTable';
import { TrialRejectedDevicesTableColumnCaptions } from './tableColumnCaptions';
import { jsonColumn } from './tableUtils';

const TrialRejectedDeviceHistoryTable = props => {
  const columns = [{
    dataField: 'eventDateTime',
    text: 'Event time',
    sort: true,
    filter_: { type: 'datetime' },
  }, {
    dataField: 'eventName',
    text: 'Event name',
    sort: true,
    filter_: { type: 'text' },
  }, {
    dataField: 'previous',
    text: 'Previous values',
    filter_: { type: 'text' },
  }, {
    dataField: 'user.login',
    text: 'User',
    sort: true,
    filter_: { type: 'text' },
  }];

  const defaultSorted = [{
    dataField: 'eventDateTime',
    order: 'desc'
  }];

  return (
    <FilterTable
      {...props}
      objectName="trialRejectedDevicesHistory"
      data={props.history.map(histrec => ({
        ...histrec,
        previous: jsonColumn(histrec.previousValues, TrialRejectedDevicesTableColumnCaptions)
      }))}
      columns={columns}
      defaultSorted={defaultSorted}
      noDataIndication="There are no trial rejected device history records"
    />
  );
};

export default TrialRejectedDeviceHistoryTable;



// WEBPACK FOOTER //
// ./src/components/trialRejectedDeviceHistoryTable.js